import storage from 'store'
import expirePlugin from 'store/plugins/expire'
storage.addPlugin(expirePlugin)
const goodsList = {
  state: {
    defaultColumns: [],
    hasDefaultSettings: false,
    tableSwitchMap: [
      {
        key: 'merchandiseBrand',
        title: '商品品牌',
        checked: true,
      },
      {
        key: 'merchandiseType',
        title: '商品品类',
        checked: true,
      },
      {
        key: 'ecommercePlatform',
        title: '电商平台',
        checked: true,
      },
      {
        key: 'merchandiseTitle',
        title: '商品文案',
        checked: true,
      },
      {
        key: 'questions',
        title: '商品问答',
        checked: true,
      },
      {
        key: 'createTime',
        title: '创建时间',
        checked: true,
      },
    ],
  },

  mutations: {
    HANDEL_DEFAULT_COLUMNS: (state, defaultColumns) => {
      state.defaultColumns = defaultColumns
    },
    SET_HAS_DEFAULT_SETTINGS: (state, hasDefaultSettings) => {
      state.hasDefaultSettings = hasDefaultSettings
    },
    HANDLE_CHECKED(state, [eTargetChecked, itemIndex]) {
      state.tableSwitchMap[itemIndex].checked = eTargetChecked
    },
  },

  actions: {},
}

export default goodsList
